import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid2,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import { useNavigate } from "react-router-dom";
import magam from "../../../../src/assest/images/magam.svg";
import { useState } from "react";
import MaterialSelect from "../../../components/MaterialSelect";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const Buy = () => {
  const navigate = useNavigate();
  const [selectCompanyPopup, setSelectCompanyPopUp] = useState(false);

  const handleNavigatePlan = () => {
    navigate("/buy-plan/health-plan-details");
  };
  const handleClose = () => {
    setSelectCompanyPopUp(false);
  };
  return (
    <DashboardLayout>
      <Grid2 container spacing={2} sx={{ padding: "10px" }}>
        <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
          <Card sx={{ padding: "10px", backgroundColor: "#ffffff" }}>
            <Grid2
              container
              direction="row"
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid2 size={{ xs: 6, sm: 6, md: 6 }}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <img
                    src={magam}
                    alt="Buy Plan"
                    style={{ width: "50%", height: "50%" }}
                  />
                </Box>
              </Grid2>
              <Grid2
                size={{ xs: 6, sm: 6, md: 6 }}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <MaterialButton
                  variant="contained"
                  color="success"
                  size="small"
                  onClick={() => setSelectCompanyPopUp(true)}
                >
                  Buy
                </MaterialButton>
              </Grid2>
            </Grid2>
            <Grid2 container direction="row" spacing={2}>
              <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
                <MaterialTypography variant="caption" color="dark">
                  Group Health Insurance Plan 4
                </MaterialTypography>
              </Grid2>
            </Grid2>
          </Card>
        </Grid2>
      </Grid2>

      <Dialog
        open={selectCompanyPopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: "600px",
            maxWidth: "100%",
            padding: 3,
          },
        }}
      >
        <DialogTitle>Select Company</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Grid2 container>
            <Grid2 size={{ xs: 12, sm: 4, md: 12 }}>
              <MaterialSelect />
            </Grid2>
          </Grid2>

          <Box
            sx={{
              alignContent: "center",
              padding: "30px 0",
            }}
          >
            <button
              style={{
                width: "47%",
                margin: "2px",
                border: "none",
                backgroundColor: "gray",
                color: "white",
                padding: "10px 5px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              onClick={() => handleClose()}
            >
              Close
            </button>
            <button
              style={{
                width: "47%",
                margin: "2px",
                border: "none",
                backgroundColor: "blue",
                color: "white",
                padding: "10px 5px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              onClick={handleNavigatePlan}
            >
              Submit
            </button>
          </Box>
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
};

export default Buy;
